import { object } from '@/shared/libs/yup';
import { helpMessageSchema } from '@/app/form/fields/user/help-message';

export const createValidationSchema = () => object({
  input: helpMessageSchema.required(),
});